import axios from 'axios'

const baseUrl = process.env.REACT_APP_API_URL;
const sortBlockLink = async(linkListData) => {
    const userID = JSON.parse(localStorage.getItem('user')).userid
    const path = `/api/user/sortBlock`
    const url = baseUrl + path
    const headingCustomizationData = {
        sortBlock: linkListData,
        userID,
    }

    const response = await axios.post(url, headingCustomizationData)
    return response.data
}
const sortBlockService = {
    sortBlockLink,
}

export default sortBlockService